<nz-spin class="retention-purchase__spin" [nzSpinning]="submitting" testId="point-package-purchase-spin">
  <div class="retention-purchase point-package-purchase" [class.is-numeric-addon]="isNumericAddon" testId="point-package-purchase-modal">
    <div class="retention-purchase__hero">
      <div>
        <div class="retention-tabs">
          <button
            type="button"
            class="retention-tabs__item"
            *ngFor="let tab of availableTabs"
            [class.is-active]="activeTab === tab.key"
            (click)="selectOverviewTab(tab.key)"
            [testId]="'point-package-tab-' + tab.key"
          >
            {{ tab.label }}
          </button>
        </div>
        <h2 class="retention-purchase__title">{{ productTitle }}</h2>
        <p class="retention-purchase__subtitle">{{ productSubtitle }}</p>
      </div>
      <button
        type="button"
        class="retention-purchase__close"
        (click)="close()"
        [attr.aria-label]="'common.close' | i18n"
        testId="point-package-purchase-close-button"
        >×</button
      >
    </div>

    <ng-container *ngIf="hasOptions; else emptyTpl">
      <ng-container *ngIf="showPurchaseTab; else unpaidTabTpl">
        <div class="point-package-purchase__scenario" *ngIf="hasUnpaidOrder" testId="point-package-purchase-hint">
          {{ purchaseHint }}
        </div>

        <div class="point-package-purchase__layout">
          <div class="point-package-purchase__options-panel">
            <div class="point-package-purchase__options">
              <button
                type="button"
                class="option-card point-option-card"
                *ngFor="let option of options; let i = index"
                [class.is-selected]="selectedOption?.pricingItemId === option.pricingItemId"
                (click)="selectOption(option)"
                [testId]="'point-package-option-' + i"
              >
                <div class="option-card__title-row">
                  <div class="option-card__title">{{ option.title }}</div>
                  <span class="point-option-card__tag point-option-card__tag--recommend" *ngIf="option.recommend">
                    {{ 'pricing.package.tag.recommend' | i18n }}
                  </span>
                </div>
                <div class="point-option-card__meta">
                  <div class="point-option-card__points">
                    <span *ngIf="isNumericAddon">+</span>{{ formatNumber(getSelectedValue(option)) }}
                    <span>{{ isNumericAddon ? productUnit : ('quota.view.point-card.unit' | i18n) }}</span>
                  </div>
                  <div class="point-option-card__price">{{ formatCurrency(option.priceCny) }}</div>
                </div>
                <div class="option-card__desc" *ngIf="getOptionDescription(option)">{{ getOptionDescription(option) }}</div>
              </button>
            </div>
          </div>

          <div class="selected-card point-package-purchase__summary" *ngIf="selectedOption">
            <div class="point-package-purchase__summary-kicker">
              <span class="point-package-purchase__summary-icon" aria-hidden="true"></span>
              <span>{{ 'quota.view.point-package.modal.summary-title' | i18n }}</span>
            </div>
            <div class="selected-card__row" *ngIf="!isNumericAddon">
              <span>{{ 'quota.view.point-package.modal.package-price' | i18n }}</span>
              <strong>{{ selectedOption.title }}</strong>
            </div>
            <div class="selected-card__row" *ngIf="!isNumericAddon">
              <span>{{ 'quota.view.point-package.modal.total-points' | i18n }}</span>
              <strong>{{ formatNumber(getTotalPoints(selectedOption)) }}</strong>
            </div>
            <div class="selected-card__row" *ngIf="!isNumericAddon">
              <span>{{ 'quota.view.point-package.modal.base-points' | i18n }}</span>
              <strong>{{ formatNumber(selectedOption.basePoints) }}</strong>
            </div>
            <div class="selected-card__row" *ngIf="isNumericAddon">
              <span>{{ 'quota.view.numeric-addon.modal.addon-value' | i18n }}</span>
              <strong>+{{ formatNumber(getSelectedValue(selectedOption)) }} {{ productUnit }}</strong>
            </div>
            <div class="selected-card__row">
              <span>{{ 'quota.view.point-package.modal.bonus-points' | i18n }}</span>
              <strong>+{{ formatNumber(selectedOption.bonusPoints) }}</strong>
            </div>
            <div class="cost-summary__divider"></div>
            <div class="selected-card__row selected-card__row--price">
              <span>{{ 'quota.view.point-package.modal.payable' | i18n }}</span>
              <strong>{{ formatCurrency(getSelectedPrice()) }}</strong>
            </div>

            <div
              class="point-package-purchase__deduct"
              *ngFor="let card of balanceCards"
              [testId]="'point-package-deduct-card-' + card.type"
            >
              <div class="deduct-card__head point-package-purchase__deduct-head">
                <div class="point-package-purchase__deduct-title">{{ getBalanceTypeLabel(card.type) }}</div>
                <div class="deduct-card__meta">{{ getUnpaidOrderBalancePointsLabel(card.points) }}</div>
              </div>
              <div class="deduct-card__controls">
                <input
                  class="deduct-input"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  [ngModel]="deductionInputs[card.type]"
                  (beforeinput)="blockNonIntegerInput($event)"
                  (input)="onDeductInput(card.type, $event)"
                  [placeholder]="'quota.view.point-package.modal.input-deduct-points' | i18n"
                  [testId]="'point-package-deduct-input-' + card.type"
                  [disabled]="hasUnpaidOrder"
                />
                <button
                  nz-button
                  nzType="default"
                  nzSize="small"
                  class="deduct-card__all"
                  (click)="deductAll(card.type)"
                  [disabled]="hasUnpaidOrder"
                  [testId]="'point-package-deduct-all-button-' + card.type"
                >
                  {{ 'quota.view.point-package.modal.use-all' | i18n }}
                </button>
              </div>
              <div class="deduct-card__foot">
                <div class="deduct-rate">{{ getDeductRateText(card.deductRate) }}</div>
                <div class="deduct-amount">{{ getDeductAmountText(card.type) }}</div>
              </div>
            </div>
            <div class="cost-summary point-package-purchase__final-summary">
              <div class="cost-summary__row" [hidden]="getDeductPoints('uupon') <= 0">
                <span>{{ getBalanceTypeLabel('uupon') }}</span>
                <strong>-{{ formatCurrency(getDeductedCash('uupon')) }}</strong>
              </div>
              <div class="cost-summary__row cost-summary__row--payable">
                <span>{{ 'quota.view.point-package.modal.payable' | i18n }}</span>
                <strong>{{ formatCurrency(getPayableCash()) }}</strong>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #unpaidTabTpl>
        <div class="point-package-purchase__unpaid-view" *ngIf="showUnpaidTab" testId="point-package-unpaid-view">
          <div class="retention-insight retention-insight--warning">
            <div class="retention-insight__title">{{ 'quota.view.point-package.modal.unpaid-title' | i18n }}</div>
            <div class="retention-insight__body">
              <div class="retention-insight__row">
                <span>{{ 'quota.view.point-package.modal.package-price' | i18n }}</span>
                <strong>{{ selectedOption?.title || '--' }}</strong>
              </div>
              <div class="retention-insight__row">
                <span>{{ 'quota.view.point-package.modal.unpaid-status-label' | i18n }}</span>
                <strong>{{ unpaidOrderStatusText }}</strong>
              </div>
              <div class="retention-insight__row">
                <span>{{ 'quota.view.point-package.modal.payable' | i18n }}</span>
                <strong>{{ unpaidOrderPriceText }}</strong>
              </div>
              <div class="retention-insight__row">
                <span>{{ 'quota.view.point-package.modal.unpaid-created-at' | i18n }}</span>
                <strong>{{ unpaidOrderCreateTimeText }}</strong>
              </div>
              <div class="retention-insight__row">
                <span>{{ 'quota.view.point-package.modal.unpaid-expire-at' | i18n }}</span>
                <strong>{{ unpaidOrderExpireTimeText }}</strong>
              </div>
            </div>
            <div class="retention-insight__hint">{{ unpaidOrderHint }}</div>
            <div class="retention-insight__actions">
              <button
                nz-button
                nzType="primary"
                class="retention-insight__button"
                *ngIf="!isUnpaidOrderExpired"
                [disabled]="submitting"
                (click)="continueUnpaidOrderPayment()"
                testId="point-package-continue-unpaid-button"
              >
                {{ 'quota.view.point-package.modal.continue-pay' | i18n }}
              </button>
              <button
                nz-button
                nzType="default"
                class="retention-insight__button retention-insight__button--danger"
                [disabled]="submitting"
                (click)="cancelUnpaidOrder()"
                testId="point-package-delete-unpaid-button"
              >
                {{ 'quota.view.point-package.modal.cancel-unpaid' | i18n }}
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <section class="point-package-purchase__terms" *ngIf="showPurchaseTab && isNumericAddon">
        <div class="point-package-purchase__terms-title">{{ 'quota.view.numeric-addon.modal.terms-title' | i18n }}</div>
        <ul>
          <li>{{ 'quota.view.numeric-addon.modal.terms-immediate' | i18n }}</li>
          <li>{{ 'quota.view.numeric-addon.modal.terms-nonrefundable' | i18n }}</li>
          <li>{{ 'quota.view.numeric-addon.modal.terms-pending' | i18n }}</li>
        </ul>
      </section>

      <div class="payment-actions" *ngIf="showPurchaseTab">
        <div class="point-package-purchase__footnote">
          <i nz-icon nzType="clock-circle" aria-hidden="true"></i>
          <span>{{ 'quota.view.point-package.modal.footer-note' | i18n }}</span>
        </div>
        <div class="point-package-purchase__footer-actions">
          <button
            nz-button
            nzType="primary"
            [nzLoading]="submitting"
            [disabled]="submitting || !canCreateNewOrder"
            (click)="confirmPay()"
            testId="point-package-confirm-pay-button"
          >
            {{ 'quota.view.point-package.modal.confirm-pay' | i18n }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyTpl>
      <nz-empty [nzNotFoundContent]="'quota.view.point-package.modal.empty' | i18n" />
    </ng-template>
  </div>
</nz-spin>
